const getGridStyle = ({ layout }) => {
  return {
    display: "grid",
    width: "100%",
    gridTemplateColumns: `repeat(${layout.columns}, 1fr)`,
    gridAutoRows: "minmax(min-content, max-content) 1fr"
  };
};
export {
  getGridStyle
};
//# sourceMappingURL=grid-options.js.map
